import { createFileRoute } from '@tanstack/react-router'

import { DriverRecharge } from '@/pages/driver-recharge'

export const Route = createFileRoute('/_protected/driver-recharge/')({
    component: DriverRecharge,
    validateSearch: (search) => {
        return {
            state: search.state ? String(search.state) : undefined,
        }
    },
})
